<template>
<div class="containern" >
    <div class="body-wrapper">
        <div class="body-title">
            <h5 style="color:#2284ab">Profile Status</h5>
        </div>
        <div class="body-content">
            <b-card no-body>
            <b-tabs card v-model="tabIndex" @input="checkTab">
                <b-tab title="Applicant Details" key="01" active>
                    <PersonalDetails @clicked="tabIndex++"></PersonalDetails>
                </b-tab>
                <b-tab title="Address Details" key="02">
                    <AddressDetails @clicked="tabIndex++"></AddressDetails>
                </b-tab>
                <b-tab title="Physical Details" key="03">
                    <PhysicalDetails @clicked="tabIndex++"></PhysicalDetails>
                </b-tab>
                <b-tab title="Family Details" key="04">
                    <Family @clicked="tabIndex++"></Family>
                </b-tab>
                <b-tab title="Nomination" key="05">
                    <NomineeDetails @clicked="tabIndex++"></NomineeDetails>
                </b-tab>
                <!-- <b-tab title="Experience" key="06" :disabled="getRegTyp == 0 || getRegTyp == 3"> -->
                <b-tab title="Experience" key="06">
                    <Experience v-if="getRegTyp != 0 && getRegTyp != 3" @clicked="tabIndex++"></Experience>
                    <ExperienceNewGuard  v-if="getRegTyp == 0 && (getExperience=='true' || getExperience==true)" @clicked="tabIndex++"></ExperienceNewGuard>
                </b-tab>
                <b-tab title="Qualification" key="07">
                    <Qualification @clicked="tabIndex++"></Qualification>
                </b-tab>
                <b-tab title="Document Upload" key="08">
                    <FormUploads @clicked="tabIndex++"></FormUploads>
                </b-tab>
                <b-tab title="Board Choice" key="09" :disabled="getRegTyp != 0">
                    <BoardChoices @clicked="tabIndex++"></BoardChoices>
                </b-tab>
                <b-tab title="Declaration" key="10">
                    <Declaration @clicked="tabIndex++"></Declaration>
                </b-tab>
                <b-tab title="Payment And Summary" key="11" >
                    <Summary ref="summary"></Summary>
                </b-tab>
                <b-tab title="Fees" key="12" v-if="getRegTyp == -1">
                    <!-- <FeesPayment></FeesPayment> -->
                    <FeesPaymentBD ></FeesPaymentBD>
                </b-tab>
            </b-tabs>
            </b-card>
        </div>
    </div>
</div>
</template>

<script>
import AddressDetails from "@/components/RegistrationDetails/AddressDetails";
import PersonalDetails from "@/components/RegistrationDetails/PersonalDetails";
import PhysicalDetails from "@/components/RegistrationDetails/PhysicalDetails";
import NomineeDetails from "@/components/RegistrationDetails/Nomination";
import Qualification from "@/components/RegistrationDetails/Qualification";
import FormUploads from "@/components/RegistrationDetails/FormUploads";
import Declaration from "@/components/RegistrationDetails/Declaration";
import FeesPayment from "@/components/RegistrationDetails/FeesPayment";
import Experience from "@/components/RegistrationDetails/Experience";
import ExperienceNewGuard from "@/components/RegistrationDetails/ExperienceNewGuard";
import Family from "@/components/RegistrationDetails/Family";
import Summary from "@/components/RegistrationDetails/Summary";
import BoardChoices from "@/components/RegistrationDetails/BoardChoices";
import FeesPaymentBD from '@/components/RegistrationDetails/FeesPaymentBD'
export default {
  components: {
    AddressDetails,
    PersonalDetails,
    PhysicalDetails,
    NomineeDetails,
    Qualification,
    FormUploads,
    Declaration,
    FeesPayment,
    Experience,
    ExperienceNewGuard,
    Family,
    Summary,
    BoardChoices,
    FeesPaymentBD
  },
  computed: {
    getRegTyp() {
        let x = this.$store.getters.getRegTyp;
        //console.log (x);
        return x;
    },
    getExperience(){
        return this.$store.getters.getExperienceFlag;
    }
  },
  data(){
      return{
          tabIndex:0
      }
  },
  methods:{
      checkTab(n){
          if(n<11){
              this.$refs.summary.CheckStatus();
          }
      }
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
.nav>li>a {
    height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/EditProfile.vue